export const encodeGetParams = (p, arraying = false) =>
  Object.entries(p || {})
    .filter((kv) => {
      return ![undefined, null, ''].includes(kv[1])
    })
    .map((kv) => {
      if(arraying & Array.isArray(kv[1])) {
        let paramString = ''
        kv[1].forEach((value) => {
          paramString += [kv[0], value].map(encodeURIComponent).join('=') + '&'
        })
        paramString = paramString.slice(0, -1)
        return paramString
      } else {
        return kv.map(encodeURIComponent).join('=')
      }})
    .join('&')

export const implode = (arr, delimiter = '-') => {
  return arr.join(delimiter)
}

export const explode = (str, delimiter = '-') => {
  return str.split(delimiter)
}

export const errorHandler = (funcName, err) => {
  throw new Error(`Error on ${funcName}: ${err.toString()}`)
}

/**
 * @param {Number[]} adultNums
 * @param {Number[]} childNums
 * @param {Number[][]} childAges
 * @returns {{adultNum: String, childNum: String, childAge: String}}
 */
export const buildPassengerParams = (adultNums, childNums = [], childAges = []) => {
  const params = {}
  const hasChild = childNums.some(num => num > 0)
  params.adultNum = implode(adultNums)
  if (hasChild) {
    // Avoid generate 0-0-... param
    params.childNum = implode(childNums)
    params.childAge = implode(childAges.map(age => {
        return Array.isArray(age) ? implode(age, ',') : age
      })
    )
  }
  return params
}

export const parseRoomNumber = (param, maxRoom, defaultValue = 1) => {
  const value = Number(param) || defaultValue
  if (value <= 0 || value > maxRoom) {
    return defaultValue
  }
  return value
}

export const parsePersonNumber = (param, maxPerson, defaultValue = 1) => {
  const value = Number(param) || defaultValue
  if (value <= 0 || value > maxPerson) {
    return defaultValue
  }
  return value
}

export const parseChildAge = (param, maxChildAge, defaultValue = 0) => {
  const value = Number(param) || defaultValue
  if (value <= 0 || value > maxChildAge) {
    return defaultValue
  }
  return value
}
